// Me store entryfile
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// Initial state
const state = {
  blocks: null,
  fields: null,
  types: {},
  module: {
    blog: {
      data: {},
      content: [],
      blocks: [],
    },
    news: {},
    press: {},
    page: {},
  },
};

export default {
  actions,
  mutations,
  state,
  getters,
};
